<template>
  <div class="wallet-page">
    <div class="balance-box" :class="{ 'loading': isLoadingBalance }">
      <div class="item" v-for="balance in balances" :key="balance.id">
        <div class="item-head">
          <img src="/images/icons/balance-2.png" alt="Balance">
          <span>{{ balance.name }}</span>
        </div>
        <div class="item-body">
          <p>
            <span class="number">{{ balance.beautyBalance }}</span>
            <span class="text">{{ balance.displaySymbol }}</span>
            <span class="text text-estimate">{{ balance.beautyBalanceUsdt }}</span>
            <span class="text"> USDT</span>
          </p>
        </div>
      </div>
    </div>
    <div class="table-box">
      <div class="table-control">
        <div class="item-head">
          <span>Transaction History</span>
        </div>
      </div>
      <div class="table-fixed-wrap">
        <div class="table-box-inner">
          <dl>
            <dt>
              <div class="item-no">{{ $t('TEXT_NO') }}.</div>
              <div>{{ $t('TEXT_TYPE') }}</div>
              <div>{{ $t('TEXT_FROM') }}</div>
              <div>{{ $t('TEXT_TO') }}</div>
              <div>{{ $t('TEXT_CURRENCY') }}</div>
              <div>{{ $t('TEXT_AMOUNT') }}</div>
              <div>{{ $t('TEXT_STATUS') }}</div>
              <div>{{ $t('TEXT_DATE') }}</div>
            </dt>
            <dd v-for="(tran, index) in transactionHistory.data" :key="index">
              <div class="item-no">{{ index + 1 }}</div>
              <div>{{ tran.type }}</div>
              <div>{{ tran.fromAddress }}</div>
              <div>{{ tran.toAddress }}</div>
              <div>{{ tran.currency }}</div>
              <div>{{ tran.amount }}</div>
              <div>{{ tran.status }}</div>
              <div>{{ tran.beautyCreatedAt }}</div>
            </dd>
            <el-pagination
              v-if="pagination.totalPage"
              :current-page="pagination.currentPage"
              :page-count="pagination.totalPage"
              background
              layout="prev, pager, next"
              @current-change="goToPage"
              :hide-on-single-page="true"
            >
            </el-pagination>
            <dd v-else class="no-data-wrap">
              <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
            </dd>
          </dl>
        </div>
      </div>

    </div>
    <el-dialog :visible.sync="isShowAmountForm" :close-on-click-modal="false"
      :destroy-on-close="true" class="popup-form">
      <component
        :wallet="currentWallet"
        :feeWallet="currentFeeWallet"
        :is="currentTypeComponent"
        transition="fade"
        transition-mode="out-in"
      />
    </el-dialog>
  </div>
</template>

<script>
import WithdrawForm from '@/views/dashboard/components/WithdrawForm'
import TransferForm from '@/views/dashboard/components/MainTransferForm'
import TransferInternalForm from '@/views/dashboard/components/TransferInternal'
export default {
  data () {
    return {
      currentType: null,
      currentWallet: {},
      currentFeeWallet: {},
      interval: null,
      intervalDone: true,
      isLoadingBalance: false
    }
  },
  computed: {
    isShowAmountForm: {
      get () {
        return this.$store.getters.isShowAmountForm
      },
      set (val) {
        this.$store.dispatch('toggleAmountForm')
      }
    },
    isLockedTransferInternal () {
      return !this.configs.isAllowTransferInternal || !this.user.allowTransferInternal
    },
    isLockedWithdraw () {
      return !this.configs.isAllowWithdraw || !this.user.allowWithdraw
    },
    isLockedSwap () {
      return !this.configs.isAllowSwap || !this.user.allowSwap
    },
    isLockedTransfer () {
      return !this.configs.isAllowTransfer || !this.user.allowTransfer
    },
    configs () {
      return this.$store.getters.configs
    },
    user () {
      return this.$store.getters.user
    },
    currentTypeComponent () {
      let comp = null
      switch (this.currentType) {
        case 'WITHDRAW':
          comp = WithdrawForm
          break
        case 'TRANSFER':
          comp = TransferForm
          break
        case 'TRANSFER_INTERNAL':
          comp = TransferInternalForm
          break
        default:
          break
      }
      return comp
    },
    balances () {
      return this.$store.getters.balances
    },
    transactionHistory () {
      return this.$store.getters.transactionHistory
    },
    pagination () {
      return this.$store.getters.pagination
    }
  },
  created () {
    this.isLoadingBalance = true
    this.$store.dispatch('getBalances').then(rs => {
      setTimeout(() => {
        this.isLoadingBalance = false
      }, 500)
    })
    this.$store.dispatch('getTransHistory', 1)
    this.updateBalance()
  },
  methods: {
    updateBalance () {
      console.log('udpate balance')
      if (this.interval) return
      this.interval = setInterval(() => {
        if (!this.intervalDone) return
        this.intervalDone = false
        this.$store.dispatch('getBalances').then(rs => {
          this.intervalDone = true
        })
      }, 1500)
    },
    stake () {
      this.$store.dispatch('sendTransaction')
    },
    doAction (wallet, type) {
      this.currentWallet = wallet
      this.currentFeeWallet = wallet
      if (type === 'WITHDRAW') {
        if (!wallet.allowWithdraw || this.isLockedWithdraw || wallet.balanceMain === 0) {
          return
        }
        if (wallet.withdrawFeeSymbol && wallet.withdrawFeeSymbol !== wallet.symbol) {
          this.currentFeeWallet = this.balances.filter((temp) => temp.symbol === wallet.withdrawFeeSymbol)[0] || wallet
        }
      } else if (type === 'SWAP') {
        if (!wallet.allowSwap || this.isLockedSwap) {
          return
        }
      } else if (type === 'TRANSFER') {
        if (this.isLockedTransfer || wallet.balanceMain === 0) {
          return
        }
      } else if (type === 'TRANSFER_INTERNAL') {
        if (this.isLockedTransferInternal || wallet.balanceMain === 0 || !wallet.allowTransferInternal) {
          return
        }
        if (wallet.transferInternalFeeSymbol && wallet.transferInternalFeeSymbol !== wallet.symbol) {
          this.currentFeeWallet = this.balances.filter((temp) => temp.symbol === wallet.transferInternalFeeSymbol)[0] || wallet
        }
      }
      this.currentType = type
      this.$store.dispatch('toggleAmountForm')
    },
    getHistory (page) {
      this.$store.dispatch('getTransHistory', page)
    },
    goToPage (page) {
      const temp = JSON.parse(JSON.stringify(this.pagination))
      temp.page = page
      this.$store.dispatch('setPagination', temp)
      this.getHistory(page)
    }
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>
